import React from 'react';
import Modal from "react-bootstrap/Modal";

const ModalFooter = (props) => {
  const {isLoading, handleSubmit, handleClose} = props;
    return (
        <div>
           <Modal.Footer>
          <button
            className="btn gray_btn px-3 py-1"
            variant="secondary"
            onClick={handleClose}
          >
            Close
          </button>
          <button className="btn blue_btn px-3 py-1" variant="primary" onClick={handleSubmit} disabled={isLoading}>
            Send Request
          </button>
        </Modal.Footer>
        </div>
    );
};

export default ModalFooter;